/** @graphql agg **/
import { fetchQuery, graphql, type GraphQLTaggedNode } from 'react-relay';

import { getRelayEnvironment } from '@confluence/graphql-provider/entry-points/relayEnvironment.ts';

import type { ReactedActorsQuery as ReactedActorsQueryType } from './__generated__/ReactedActorsQuery.graphql.ts';

export type ReactedActorsInput = ReactedActorsQueryType['variables']['input'];

export const ReactedActorsQuery: GraphQLTaggedNode = graphql`
	query ReactedActorsQuery($cloudId: ID!, $input: ConfluenceReactedUsersInput!) {
		confluence_reactedActors(cloudId: $cloudId, input: $input) {
			actors {
				agentId
				agentType
				person {
					accountId
					displayName
					profilePicture {
						path
					}
				}
			}
			emojiId
			count
			reacted
			success
		}
	}
`;

export const fetchReactedActors = async (
	cloudId: string,
	input: ReactedActorsInput,
): Promise<NonNullable<ReactedActorsQueryType['response']['confluence_reactedActors']>> => {
	const data = await fetchQuery<ReactedActorsQueryType>(
		getRelayEnvironment(),
		ReactedActorsQuery,
		{ cloudId, input },
		{ fetchPolicy: 'network-only' },
	).toPromise();
	if (!data?.confluence_reactedActors?.success) {
		throw new Error('Failed to load reaction actors');
	}
	return data.confluence_reactedActors;
};
